import { useEffect, useRef, useState } from 'react';

/**
 * Wrap any element to have it slide in fast from the left the moment
 * it scrolls into view (plays once). Used on each step's title.
 */
export default function RevealLeft({ children, className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal-left ${visible ? 'is-visible' : ''} ${className}`}>
      {children}
    </div>
  );
}